import React from 'react';
import { useTranslation } from 'react-i18next';

import { UNIT_LABEL } from '@/constants/energy';

import { PERIOD_LABEL_KEY } from '../../constants';
import {
  type UseEnergyConsumptionParams,
  useEnergyConsumption,
} from '../../hooks/useEnergyConsumption';

import { EnergyConsumptionCard } from './EnergyConsumptionCard';

export const EnergyConsumptionCardContainer: React.FC<
  UseEnergyConsumptionParams & { href?: string }
> = ({ href, ...params }) => {
  const { t, i18n } = useTranslation();
  const {
    total,
    unit,
    trendPercent,
    cost,
    costUnit,
    isLoading,
    isError,
    retry,
  } = useEnergyConsumption(params);

  const formatNumber = (value: number) =>
    Math.round(value).toLocaleString(i18n.language);

  return (
    <EnergyConsumptionCard
      value={formatNumber(total ?? 0)}
      unit={unit ? UNIT_LABEL[unit] : ''}
      trendPercent={trendPercent}
      cost={
        cost !== null && costUnit
          ? `${UNIT_LABEL[costUnit]}${formatNumber(cost)}`
          : null
      }
      periodLabel={t(PERIOD_LABEL_KEY[params.timeSpan])}
      isLoading={isLoading}
      isError={isError}
      isEmpty={!isLoading && total === null}
      onRetry={retry}
      href={href}
    />
  );
};
